/**
 * Meta Pixel — helpers de rastreamento.
 *
 * O script base do pixel é carregado no index.html, então `window.fbq` já
 * costuma existir quando estes helpers rodam. Ainda assim checamos antes de
 * chamar: em SPA o React pode montar antes do script terminar de carregar, e
 * bloqueadores de anúncio removem `fbq` por completo.
 */

export const PIXEL_ID = '1441454858041242';

type FbqParams = Record<string, unknown>;

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

function fbq(...args: unknown[]) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq(...args);
}

/** Evento padrão de visualização de página (usado nas trocas de rota da SPA). */
export function trackPageView() {
  fbq('track', 'PageView');
}

/** Evento padrão de lead — dispare somente após o envio bem-sucedido do form. */
export function trackLead(params?: FbqParams) {
  fbq('track', 'Lead', params);
}

/** Eventos customizados (ex.: cliques em CTA de WhatsApp). */
export function trackCustom(event: string, params?: FbqParams) {
  fbq('trackCustom', event, params);
}
